import React from "react";
import { classifyLabel } from "../lib/api";

export function ScoreBadge({ score }) {
  const c = classifyLabel(score);
  return (
    <span className={`badge ${c.key}`} data-testid={`score-badge-${c.key}`}>
      {c.label} · {score}
    </span>
  );
}

export function ScoreRing({ score }) {
  const c = classifyLabel(score);
  const pct = Math.max(0, Math.min(1, Number(score || 0) / 1000));
  const angle = pct * 360;
  return (
    <div
      className="score-ring"
      style={{ background: `conic-gradient(#0A0A0A 0deg ${angle}deg, #EBE5DF ${angle}deg 360deg)` }}
      data-testid="score-ring"
    >
      <div className="inner">
        <div className="num">{score}</div>
        <div className="label">{c.label}</div>
      </div>
    </div>
  );
}

export function StatusBadge({ status }) {
  const map = {
    active: { key: "green", label: "Ativo" },
    blocked: { key: "red", label: "Bloqueado" },
    observation: { key: "medio", label: "Observacao" },
    defaulter: { key: "red", label: "Inadimplente" },
    pending: { key: "neutral", label: "Pendente" },
    paid: { key: "green", label: "Pago" },
    late: { key: "red", label: "Atrasado" },
    pending_signature: { key: "medio", label: "Aguarda assinatura" },
    cancelled: { key: "neutral", label: "Cancelado" },
  };
  const v = map[status] || { key: "neutral", label: status };
  return <span className={`badge ${v.key}`}>{v.label}</span>;
}
